import { Injectable } from '@angular/core';
import { RequestState, RequestStatus } from '@shared/models/request-state';
import { map, Observable } from 'rxjs';
import { CrewDetail, MemberDetail } from '../model/crew-detail';
import { environment } from '@environments/environment';
import { ApiCacheService } from '@shared/services/cache-service/api-cache.service';
import { CrewMember } from '../model/crew-member';

@Injectable({
  providedIn: 'root',
})
export class FlightdetailService {
  constructor(
    private cacheService: ApiCacheService
  ) { }

  private readonly _crewBasicUrl = `${environment.crewBasicUrl}`


  // Crew User API service (crew basic info like name, emp number, etc)
  getCrewDetailsFor(empNumber: string[], cacheId: string): Observable<RequestState<CrewDetail[]>> {
    const url = `${this._crewBasicUrl}`

    return this.cacheService.request<MemberDetail>(cacheId, url, 'memberDetails', empNumber)
      .pipe(
        map((crewDetailResponse) => {
          if (!crewDetailResponse || !crewDetailResponse.response) {
            return new RequestState<CrewDetail[]>(
              RequestStatus.IsCompleteNoResponse
            )
          }
          let crewDetail: CrewDetail[] = [];
          if (crewDetailResponse.response) {
            for (let member of crewDetailResponse.response.memberDetails) {
              crewDetail.push({
                username: member.username,
                firstName: member.firstName,
                lastName: member.lastName,
                middleName: member.middleName,
                nickName: member.nickName,
                seat: member.seat
              })
            }
          }
          return new RequestState<CrewDetail[]>(
            RequestStatus.IsCompleteWithResponse,
            crewDetail
          )
        })
      )
  }

  getCrewMemberDetails(requestedEmpNum: string, initiatorEmpNum: string, cacheId: string): Observable<RequestState<CrewMember>> {
    const url = `${environment.crewDetailUrl}`;
    //const cachedResponse = this.getCached<CrewMember>(cacheId)

    const body = {
      searchTerm: requestedEmpNum, //empNumber to search
      userId: initiatorEmpNum, //empNumber conducting the search
      request: 0
    }

    return this.cacheService.request<CrewMember>(cacheId, url, undefined, body)
      .pipe(
        map((response) => {
          if ((!response.response || response.hasError) && !response.isLoading) {
            console.error('No response from server flight detail service');
            return new RequestState<CrewMember>(
              RequestStatus.IsCompleteNoResponse
            )
          }

          return new RequestState<CrewMember>(
            RequestStatus.IsCompleteWithResponse,
            response.response
          )
        })
      )
  }

  cacheResponse<T>(
    cacheId: string,
    response: T
  ): void {
    localStorage.setItem(cacheId, JSON.stringify(response));
  }

  private getCached<T>(cacheId: string): T | null {
    const cached = localStorage.getItem(cacheId);

    if (!cached) {
      return null;
    }

    return JSON.parse(cached) as T;
  }


}
